import { useCallback, useContext, useState } from 'react';
import { AgCheckbox } from 'app/agriculture/components/form/AgCheckbox/AgCheckbox';
import { useTask } from 'app/agriculture/queries/tasks/useTask';
import { useEntityUpdateMutation } from 'app/agriculture/mutations/entity/update/useEntityUpdateMutation';
import './TaskCompleteCheckbox.scss';
import { AgricultureToastType } from 'app/agriculture/AgricultureToast/agriculture_toast_service';
import { ServicesContext } from 'app/items/shared/context_interface';

interface TaskCompleteCheckboxProps {
    taskId: string;
}

export function TaskCompleteCheckbox({ taskId }: TaskCompleteCheckboxProps) {
    const task = useTask({ taskId });
    const { mutateAsync, isPending } = useEntityUpdateMutation('Task');
    const { agricultureToastService } = useContext(ServicesContext);
    const [isComplete, setIsComplete] = useState(task.isComplete);

    const handleChange = useCallback(
        (isComplete: boolean) => {
            if (!isPending) {
                // We need a mutateAsync because the mutate onSuccess callback isn't called if the component unmounts
                mutateAsync(
                    { id: taskId, isComplete },
                    {
                        // this gets thrown away if the component unmounts in the meantime
                        onSuccess: () => {
                            setIsComplete(isComplete);
                        },
                    },
                )
                    // this will run even if the component unmounts
                    .then(() => {
                        agricultureToastService
                            .showToast({
                                title: isComplete
                                    ? 'Task completed:'
                                    : 'Task reverted to incomplete:',
                                subtext: task.title,
                                type: AgricultureToastType.SUCCESS,
                            })
                            .catch((e) => {
                                console.error(e);
                            });
                    })
                    .catch((e) => {
                        console.error(e);
                    });
            }
        },
        [isPending, mutateAsync, taskId, task.title, agricultureToastService],
    );

    return (
        <AgCheckbox
            className="TaskCompleteCheckbox"
            id="TaskCompleteCheckbox"
            onChange={handleChange}
            isChecked={isComplete}
            disabled={isPending}
        />
    );
}
